import { createContext, useContext } from 'react'
import { Logger } from '../../../common/logger'

export const LoggerContext = createContext<Logger | null>(null)

export const useLogger = () => {
  const logger = useContext(LoggerContext)
  if (!logger) {
    throw new Error('useLogger must be used within a LoggerProvider')
  }
  return logger
}
